const enhancedModalStyles = {
  // Full page container - prevent body scroll
  overlay: {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    background: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '16px',
    boxSizing: 'border-box',
    overflowY: 'auto', // Allow scrolling on small screens
  },

  // Main container that holds all content
  box: {
    width: '100%',
    maxWidth: '1350px',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    background: 'white',
    borderRadius: '20px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    overflow: 'hidden',
    position: 'relative'
  },

  // Header section with title and close button - NOT fixed
  headerSection: {
    background: 'linear-gradient(135deg, #023e8a 0%, #0077b6 50%, #4a90e2 100%)',
    padding: '5px 30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 4px 20px rgba(2, 62, 138, 0.3)',
    position: 'relative',
    overflow: 'hidden',
    flexShrink: 0, // Prevent header from shrinking
    '::before': {
      content: '""',
      position: 'absolute',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, transparent 50%)',
      pointerEvents: 'none'
    }
  },

  // Enhanced title in header with margin
  modalTitle: {
    color: '#ffffff',
    fontSize: '26px',
    fontWeight: '800',
    letterSpacing: '1px',
    textShadow: '0 3px 8px rgba(0,0,0,0.3)',
    margin: '10px 0', // Added margin as requested
    background: 'linear-gradient(135deg, #ffffff 0%, #cce7ff 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
  },

  // Close button in header
  closeButton: {
    fontSize: '28px',
    background: 'linear-gradient(135deg, #d67b7b 0%, #c45a5a 100%)',
    border: '2px solid rgba(255, 255, 255, 0.3)',
    cursor: 'pointer',
    color: '#ffffff',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    padding: '12px 16px',
    borderRadius: '50%',
    width: '45px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(10px)',
    fontWeight: '700',
    ':hover': {
      background: 'rgba(255, 107, 107, 0.8)',
      border: '2px solid rgba(255, 107, 107, 1)',
      transform: 'scale(1.1) rotate(90deg)',
      boxShadow: '0 8px 25px rgba(255, 107, 107, 0.4)'
    }
  },

  // Main content area with scroll - this is the ONLY scrollable area
  contentArea: {
    flex: '1 1 auto',
    overflowY: 'auto',
    overflowX: 'hidden',
    background: 'linear-gradient(180deg, #f8fcff 0%, #ffffff 100%)',
    scrollbarWidth: 'thin',
    scrollbarColor: '#0077b6 #e6f3ff',
    WebkitOverflowScrolling: 'touch',
    // Custom scrollbar for WebKit browsers
    '::-webkit-scrollbar': {
      width: '8px'
    },
    '::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '10px'
    },
    '::-webkit-scrollbar-thumb': {
      background: 'linear-gradient(180deg, #0077b6, #023e8a)',
      borderRadius: '10px'
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: 'linear-gradient(180deg, #023e8a, #0077b6)'
    }
  },

  // Container for all form sections - CENTERED
  contentContainer: {
    width: '82%',
    maxWidth: '1260px',
    margin: '0 auto',
    padding: '32px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
    alignItems: 'center', // Center all content horizontally
    // Add padding bottom to ensure save button area is visible when scrolled
    paddingBottom: '40px'
  },

  // File info section at the top - CENTERED
  fileInfoSection: {
    background: 'linear-gradient(135deg, #ffffff 0%, #f8fcff 100%)',
    padding: '20px 18px',
    borderRadius: '20px',
    border: '2px solid rgba(0, 119, 182, 0.2)',
    boxShadow: '0 8px 25px rgba(0, 119, 182, 0.1)',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    width: '100%',
    maxWidth: '1120px',
    gap: '20px',
    position: 'relative',
    overflow: 'hidden',
    '::before': {
      content: '""',
      position: 'absolute',
      top: '0',
      left: '0',
      right: '0',
      height: '4px',
      background: 'linear-gradient(90deg, #0077b6, #023e8a, #4a90e2)',
      borderRadius: '20px 20px 0 0'
    }
  },

  fileInfoItem: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    gap: '10px',
    padding: '8px 16px',
    background: 'rgba(237, 246, 255, 0.75)',
    borderRadius: '16px',
    border: '1px solid rgba(0, 119, 182, 0.18)',
    boxShadow: '0 6px 16px rgba(0, 119, 182, 0.08)',
    backdropFilter: 'blur(2px)'
  },

  fileInfoLabel: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#023e8a',
    textTransform: 'uppercase',
    letterSpacing: '1px'
  },

  fileInfoValue: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#2d3748',
    padding: '8px 1px',
    background: 'rgba(0, 119, 182, 0.05)',
    borderRadius: '12px',
    width: '100%',
    maxWidth: '100%',
    margin: '0 auto',
    textAlign:'center',
    border: '1px solid rgba(0, 119, 182, 0.1)'
  },

  // Form sections container - CENTERED
  formSectionsContainer: {
    display: 'grid',
    width: '100%',
    maxWidth: '1240px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '22px'
  },

  // Individual form section
  formSection: {
    background: 'linear-gradient(135deg, #ffffff 0%, #f8fcff 100%)',
    padding: '14px 16px',
    borderRadius: '18px',
    border: '2px solid rgba(0, 119, 182, 0.15)',
    boxShadow: '0 10px 30px rgba(0, 119, 182, 0.08)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    overflow: 'hidden',
    ':hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 15px 40px rgba(0, 119, 182, 0.15)',
      borderColor: '#0077b6'
    },
    '::before': {
      content: '""',
      position: 'absolute',
      top: '0',
      left: '0',
      right: '0',
      height: '4px',
      background: 'linear-gradient(90deg, #0077b6, #4a90e2)',
      opacity: '0',
      transition: 'opacity 0.3s ease'
    },
    ':hover::before': {
      opacity: '1'
    }
  },

  // Full width sections (for owners and description) - CENTERED
  fullWidthSection: {
    gridColumn: '1 / -1',
    background: 'linear-gradient(135deg, #ffffff 0%, #f8fcff 100%)',
    padding: '18px 20px',
    borderRadius: '20px',
    width: '100%',
    maxWidth: '1120px',
    border: '2px solid rgba(0, 119, 182, 0.15)',
    boxShadow: '0 10px 30px rgba(0, 119, 182, 0.08)',
    position: 'relative',
    overflow: 'visible', // Changed to visible to allow suggestions to show
    '::before': {
      content: '""',
      position: 'absolute',
      top: '0',
      left: '0',
      right: '0',
      height: '4px',
      background: 'linear-gradient(90deg, #0077b6, #023e8a, #4a90e2)'
    }
  },

  // Section titles
  sectionTitle: {
    fontSize: '20px',
    fontWeight: '800',
    color: '#023e8a',
    marginBottom: '10px',
    paddingBottom: '12px',
    borderBottom: '3px solid rgba(0, 119, 182, 0.2)',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    position: 'relative',
    '::after': {
      content: '""',
      position: 'absolute',
      bottom: '-3px',
      left: '0',
      width: '60px',
      height: '3px',
      background: 'linear-gradient(90deg, #0077b6, #4a90e2)',
      borderRadius: '2px'
    }
  },

  // Enhanced form inputs
  modalInput: {
    width: '100%',
    padding: '14px 18px',
    border: '2px solid rgba(0, 119, 182, 0.25)',
    borderRadius: '15px',
    fontSize: '16px',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    backgroundColor: '#ffffff',
    color: '#023e8a',
    fontWeight: '500',
    boxShadow: '0 4px 12px rgba(0, 119, 182, 0.05)',
    ':focus': {
      borderColor: '#0077b6',
      boxShadow: '0 0 0 4px rgba(0, 119, 182, 0.15), 0 8px 20px rgba(0, 119, 182, 0.1)',
      transform: 'translateY(-2px)'
    }
  },

  modalSelect: {
    width: '100%',
    padding: '14px 18px',
    border: '2px solid rgba(0, 119, 182, 0.25)',
    borderRadius: '15px',
    fontSize: '16px',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    backgroundColor: '#ffffff',
    color: '#023e8a',
    fontWeight: '500',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(0, 119, 182, 0.05)',
    ':focus': {
      borderColor: '#0077b6',
      boxShadow: '0 0 0 4px rgba(0, 119, 182, 0.15), 0 8px 20px rgba(0, 119, 182, 0.1)',
      transform: 'translateY(-2px)'
    }
  },

  // Enhanced textarea
  modalTextarea: {
    width: '100%',
    padding: '14px 18px',
    border: '2px solid rgba(0, 119, 182, 0.25)',
    borderRadius: '15px',
    fontSize: '16px',
    outline: 'none',
    resize: 'vertical',
    boxSizing: 'border-box',
    backgroundColor: '#ffffff',
    color: '#023e8a',
    minHeight: '80px',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    fontFamily: 'inherit',
    fontWeight: '500',
    boxShadow: '0 4px 12px rgba(0, 119, 182, 0.05)',
    ':focus': {
      borderColor: '#0077b6',
      boxShadow: '0 0 0 4px rgba(0, 119, 182, 0.15), 0 8px 20px rgba(0, 119, 182, 0.1)',
      transform: 'translateY(-2px)'
    }
  },

  // Form labels
  formLabel: {
    display: 'block',
    marginBottom: '12px',
    fontWeight: '700',
    color: '#023e8a',
    fontSize: '16px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase'
  },

  // Owner cards
  ownerCard: {
    background: 'linear-gradient(135deg, #f8fcff 0%, #ffffff 100%)',
    border: '2px solid rgba(0, 119, 182, 0.2)',
    borderRadius: '16px',
    padding: '25px',
    marginBottom: '20px',
    boxShadow: '0 8px 20px rgba(0, 119, 182, 0.1)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    overflow: 'visible', // Changed to visible to allow search suggestions
    ':hover': {
      transform: 'translateY(-3px)',
      boxShadow: '0 12px 30px rgba(0, 119, 182, 0.15)',
      borderColor: '#0077b6'
    },
    '::before': {
      content: '""',
      position: 'absolute',
      top: '0',
      left: '0',
      width: '4px',
      height: '100%',
      background: 'linear-gradient(180deg, #0077b6, #4a90e2)',
      opacity: '0',
      transition: 'opacity 0.3s ease'
    },
    ':hover::before': {
      opacity: '1'
    }
  },

  // Owner fields container - STACKED VERTICALLY
  ownerFieldsContainer: {
    display: 'flex',
    flexDirection: 'column', // Stack vertically instead of side by side
    gap: '20px'
  },

  // Owner field group (for each input field)
  ownerFieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    position: 'relative' // For absolute positioning of suggestions
  },

  // Search suggestions - FIXED POSITIONING
  suggestionsList: {
    position: 'absolute',
    top: '100%', // Position below the input
    left: '0',
    right: '0',
    zIndex: 1000, // High z-index to appear above other elements
    marginTop: '4px',
    listStyle: 'none',
    padding: '0',
    border: '2px solid rgba(0, 119, 182, 0.2)',
    borderRadius: '15px',
    backgroundColor: '#ffffff',
    maxHeight: '200px',
    overflowY: 'auto',
    boxShadow: '0 8px 25px rgba(0, 119, 182, 0.15)',
    backdropFilter: 'blur(10px)'
  },

  suggestionItem: {
    padding: '15px 20px',
    borderBottom: '1px solid rgba(0, 119, 182, 0.1)',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: 'rgba(0, 119, 182, 0.05)',
      transform: 'translateX(5px)'
    },
    ':last-child': {
      borderBottom: 'none'
    }
  },

  // Simple save button - NO BOX WRAPPER, part of content
  saveButton: {
    padding: '16px 40px',
    background: 'linear-gradient(135deg, #0077b6 0%, #023e8a 100%)',
    color: '#fff',
    border: 'none',
    borderRadius: '25px',
    fontWeight: '800',
    cursor: 'pointer',
    fontSize: '18px',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 10px 30px rgba(0, 119, 182, 0.4)',
    textTransform: 'uppercase',
    letterSpacing: '2px',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    maxWidth: '320px',
    minWidth: 'auto',
    marginTop: '40px',
    marginBottom:'40px', // Add some space above the button
    alignSelf: 'center', // Center the button
    ':hover': {
      transform: 'translateY(-5px) scale(1.05)',
      boxShadow: '0 15px 40px rgba(0, 119, 182, 0.5)',
      background: 'linear-gradient(135deg, #023e8a 0%, #0077b6 100%)'
    },
    ':active': {
      transform: 'translateY(-2px) scale(1.02)'
    },
    '::before': {
      content: '""',
      position: 'absolute',
      top: '0',
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent)',
      transition: 'left 0.6s'
    },
    ':hover::before': {
      left: '100%'
    }
  },

  // Error styling
  errorMessage: {
    color: '#dc2626',
    backgroundColor: 'rgba(220, 38, 38, 0.1)',
    border: '2px solid rgba(220, 38, 38, 0.2)',
    borderRadius: '12px',
    padding: '16px 20px',
    marginBottom: '20px',
    fontWeight: '600',
    fontSize: '14px'
  },

  // Loading state - CENTERED
  loadingMessage: {
    color: '#0077b6',
    backgroundColor: 'rgba(0, 119, 182, 0.1)',
    border: '2px solid rgba(0, 119, 182, 0.2)',
    borderRadius: '12px',
    padding: '16px 20px',
    marginBottom: '20px',
    fontWeight: '600',
    fontSize: '14px',
    textAlign: 'center',
    width: '100%',
    maxWidth: '1120px'
  }
};

export default enhancedModalStyles;
